import { IApplicationState } from '../../types/redux';
import { IInfrastructureTypeDesktopSchema } from '../../repositories/newbuilding-card/entities/infrastructure/InfrastructureTypeDesktopSchema';

export function getInfrastructureMapTypes(state: IApplicationState): IInfrastructureTypeDesktopSchema[] {
  const { infrastructureTypes } = state.newbuilding;

  return infrastructureTypes;
}
